import { LiveWidgetStoreContext } from "@state/context/live/live-widgets";
import { useContext } from "react";

export function useLiveWidgetStore() {
	return useContext(LiveWidgetStoreContext);
}
